import { log } from '@hotjar/insights-common/lib/log';

/**
 * Quora related tracking.
 */

const callbacksAfterSetup: Array<() => void> = [];

let initialSetupComplete = false;

// Wait for Quora to load, then run any method calls that's been triggered in the meantime.
const intervalID = setInterval(() => {
  if (window.qp) {
    clearInterval(intervalID);
    initialSetupComplete = true;
    callbacksAfterSetup.forEach((callback) => {
      callback();
    });
  }
}, 500);

/**
 * If Quora is loaded it simply executes the method call. If not, it will add it to the callback queue.
 * @param callback Method call to either execute or add to queue.
 */
function callOrQueue(callback: () => void) {
  if (initialSetupComplete) {
    callback();
  } else {
    callbacksAfterSetup.push(callback);
  }
}

/**
 * Track that a user signed up.
 */
export const trackSignup = (): void => {
  callOrQueue(() => {
    if (window.qp) {
      log.debug('Quora: Tracking sign-up');
      window.qp('track', 'Generic');
    }
  });
};
